import { render, staticRenderFns } from "./AddPartInputs.vue?vue&type=template&id=2f86bcda&scoped=true"
import script from "./AddPartInputs.vue?vue&type=script&lang=ts"
export * from "./AddPartInputs.vue?vue&type=script&lang=ts"
import style0 from "./AddPartInputs.vue?vue&type=style&index=0&id=2f86bcda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f86bcda",
  null
  
)

export default component.exports